import { render, staticRenderFns } from "./ProfileTags.vue?vue&type=template&id=e28eb894&scoped=true"
import script from "./ProfileTags.vue?vue&type=script&lang=js"
export * from "./ProfileTags.vue?vue&type=script&lang=js"
import style0 from "./ProfileTags.vue?vue&type=style&index=0&id=e28eb894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28eb894",
  null
  
)

export default component.exports